import { validateEmail } from "../../utils/helper";

const useValidate = () => {
  return (schema) => {
    if (schema && Array.isArray(schema)) {
      for (let field of schema) {
        if (field.required && (!field.value || field.value === "")) {
          return field.field + " is required.";
        }
        if (field.audiogram && (!field.value || field.value === "")) {
          return field.field;
        }
        if (field.isEmail && !validateEmail(field.value)) {
          return field.field + " is not valid.";
        }
        if (
          field.isArray &&
          (!Array.isArray(field.value) || field.value.length === 0)
        ) {
          return field.field + " is required.";
        }
        if (field.custom) {
          return field.custom();
        }
      }
    }

    return true;
  };
};
export default useValidate;

// const xyz = {
//     required: true,
//     value: 'attual value',
//     field: 'name of field',
//     isEmail: true,

// }
